import { Close } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  IconButton,
  Modal,
  Snackbar,
  TextField,
  Typography
} from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as ProgramIcon } from "../../assets/book.svg";
import { ReactComponent as DiaryIcon } from "../../assets/diary.svg";
import { ReactComponent as ModIcon } from "../../assets/mod.svg";
import useThemeColor from "../../utils/useTheme";
import { useCurrentUser } from "../Extra/UserContext";
import styled from "@emotion/styled";
import { addCoupon } from "../../api/userApi";

const StyledTextField = styled(TextField)(({ theme }) => ({
  input: {
    color: "#FCFCFC"
  },
  "& .MuiOutlinedInput-root": {
    border: "2px dotted #A4A4A4",
    "& fieldset": {
      color: "#9CA3AF"
    },
    "&:hover fieldset": {
      borderColor: "#FCFCFC",
      border: "none"
    },
    "&.Mui-focused fieldset": {
      color: "#9CA3AF",
      borderColor: "#FCFCFC",
      border: "none"
    }
  }
}));

const FreeTrialModal = ({
  open,
  onClose,
  openSubscriptionModal,
  isMobile = false,
  disabledFreeTrial
}) => {
  const currentUser = useCurrentUser();
  const styles = useThemeColor();
  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [inputCouponValue, setInputCouponValue] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const handleCouponChange = (event) => {
    // Apply transformations based on CPOVP, REFDS, MNGFQ requirements here
    // For example:
    // if (event.target.value.length > 23) return;
    const existing = event.target.value.toUpperCase();
    // Insert hyphens after every 5 characters
    // const formattedValue = existing.replace(/(.{5})(?!-)/g, "$1-");

    setInputCouponValue(existing);
  };
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const handleApplyCoupon = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      if (!inputCouponValue) return;
      const { sessionUrl, message } = await addCoupon(inputCouponValue);
      if (sessionUrl) window.location.href = sessionUrl;
      else {
        setSnackbarMessage(message);
        setOpenSnackbar(true);
        setTimeout(() => {
          onClose();
          handleCloseSnackbar();
        }, 3000);
      }
    } catch (err) {
      setSnackbarMessage(err.error);
      setOpenSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      {isMobile ? (
        open ? (
          <Box
            sx={{
              position: "fixed",
              height: "100%",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1300,
              overflowY: "auto"
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
                top: "50%",
                left: "50%",
                overflow: "auto",
                width: { md: "42%", xs: "100%" },
                borderRadius: 2,
                transform: "translate(-50%, -50%)"
              }}
            >
              <Box
                sx={{
                  padding: { xs: "28px", md: 0 },
                  position: "relative",
                  bgcolor: "#000",
                  borderRadius: "16px 16px 0 0",
                  boxShadow: 24,
                  overflow: "hidden"
                }}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexDirection={"column"}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: "url(/images/sky.png)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    opacity: { xs: 1, md: 0.5 },
                    zIndex: 1
                  }}
                />
                <Box
                  sx={{
                    position: "relative",
                    zIndex: 2
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="end"
                    alignItems="flex-end"
                    width="100%"
                  >
                    {" "}
                    <IconButton
                      sx={{
                        svg: {
                          fill: "#FCFCFC"
                        }
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        onClose();
                      }}
                    >
                      <Close />
                    </IconButton>
                  </Box>
                  <Box
                    sx={{ padding: { sm: 0, md: "0 95px" } }}
                    display={"flex"}
                    gap="10px"
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                  >
                    <Box
                      component="img"
                      src="/images/threepillars.png"
                      alt="base"
                      sx={{
                        width: "68px",
                        height: "68px",
                        objectFit: "cover"
                      }}
                    />
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      gap="10px"
                      flexDirection="column"
                    >
                      <Typography
                        fontWeight={600}
                        fontSize={"24px"}
                        textAlign="center"
                        color="#FCFCFC"
                      >
                        Welcome to the Three Pillars Method
                      </Typography>
                      <Typography mt={-1} fontSize={"15px"} color="#FCFCFC">
                        {currentUser?.userType === "Company"
                          ? ""
                          : `Your 5 Day Free Trial starts now!`}
                        <br />
                        Take this time to explore all the platform has to offer.
                      </Typography>
                      {/* <Box
                    display="flex"
                    justifyContent={"center"}
                    mt={2}
                    alignItems="center"
                    gap={2}
                  >
                    <Typography fontSize={24}>🥗</Typography>
                    <Typography fontSize={"14px"} color="#FCFCFC">
                      <b>Meals of the day (MODs): </b> Get inspired with our
                      daily MODs and share yours with the community.
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"center"}
                    alignItems="center"
                    gap={2}
                  >
                    <Typography fontSize={24}> 🔊</Typography>
                    <Typography fontSize={"15px"} color="#FCFCFC">
                      <b>5 Days of the #800gChallenge Program: </b> Each day
                      will unlock a new training from EC’s #800gChallenge.
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    justifyContent={"center"}
                    alignItems="center"
                    gap={2}
                  >
                    <Typography fontSize={24}> 📒</Typography>
                    <Typography fontSize={"15px"} color="#FCFCFC">
                      <b> Simplified logging:</b> Begin tracking your daily
                      eating habits as you strive for 800g of fruits & veggies
                      each day.
                    </Typography>
                  </Box> */}
                      <Box
                        alignItems="start"
                        display="flex"
                        flexDirection="column"
                        gap={2}
                      >
                        <Box
                          display="flex"
                          justifyContent={"center"}
                          alignItems="center"
                          gap={2}
                          mt={2}
                        >
                          <Typography
                            display="flex"
                            alignItems={"center"}
                            fontSize={22}
                          >
                            <ModIcon />
                          </Typography>
                          <Typography fontSize={"15px"} color="#FCFCFC">
                            <b>Meals of the Day (MOD): </b> Get inspired with
                            daily ideas and earn a badge by sharing yours with
                            the community.
                          </Typography>
                        </Box>
                        <Box
                          display="flex"
                          justifyContent={"center"}
                          alignItems="center"
                          gap={2}
                        >
                          <Typography
                            display="flex"
                            alignItems={"center"}
                            fontSize={22}
                          >
                            <ProgramIcon />
                          </Typography>
                          <Typography fontSize={"15px"} color="#FCFCFC">
                            <b>5 Day Free Trial: </b> Each day will unlock a new
                            training for the #800gChallenge.
                          </Typography>
                        </Box>
                        <Box
                          display="flex"
                          justifyContent={"center"}
                          alignItems="center"
                          gap={2}
                        >
                          <Typography
                            display="flex"
                            alignItems={"center"}
                            fontSize={22}
                          >
                            <DiaryIcon />
                          </Typography>
                          <Typography fontSize={"15px"} color="#FCFCFC">
                            <b> Diary:</b> Keep yourself accountable with daily
                            logging; earn badges for consistency and streaks.
                          </Typography>
                        </Box>
                      </Box>
                      {currentUser?.userType === "Company" ? (
                        <></>
                      ) : (
                        <Typography
                          textAlign="center"
                          mt={2}
                          fontSize={"15px"}
                          color="#FCFCFC"
                        >
                          {currentUser?.userType === "Coach"
                            ? `At the end of the trial, you can choose to purchase the full #800gChallenge and subsequent programs.`
                            : `At the end of your free trial you can subscribe to have
                      continued access to MODs / Daily Nutrition Logging, and
                      unlock additional Training Programs.`}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
              <Box
                height={"40%"}
                sx={{
                  background: "#333333",
                  display: "flex",
                  padding: "24px 47px",
                  borderRadius: "0 0 16px 16px",
                  flexDirection: "column"
                }}
              >
                <Box mt={2} display="flex" justifyContent="center">
                  <Button
                    disabled={disabledFreeTrial}
                    sx={{
                      width: "70%",
                      color: "#368AD0",
                      textTransform: "none",
                      fontWeight: "bold"
                    }}
                    variant="none"
                    onClick={onClose}
                  >
                    Continue Free Trial
                  </Button>
                </Box>{" "}
                <Box mt={2}>
                  <Button
                    sx={{
                      background: "#368AD0",
                      color: "#FCFCFC",
                      textTransform: "none",
                      width: "100%"
                      // height: "54px"
                    }}
                    onClick={() => {
                      onClose();
                      openSubscriptionModal();
                    }}
                  >
                    Purchase Plan Now
                  </Button>
                </Box>
                {/* <Box mt={2}>
                  <Button
                    sx={{
                      background: "#368AD0",
                      color: "#FCFCFC",
                      textTransform: "none",
                      width: "100%"
                      // height: "54px"
                    }}
                    onClick={() => {
                      setCouponModalOpen(true);
                    }}
                  >
                    Apply Coupon
                  </Button>
                </Box> */}
              </Box>
            </Box>
            {couponModalOpen && (
              <Modal
                disableAutoFocus
                disableEnforceFocus
                open={couponModalOpen}
                onClose={() => {
                  setCouponModalOpen(false);
                  onClose();
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    width: "100%",
                    // height: { xs: "35%", md: "30%" },
                    // width: { xs: "65%", md: "30%" },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    borderRadius: 3,
                    background: "#1C1C1C",
                    p: 2,
                    color: "#FCFCFC",
                    transform: "translate(-50%, -50%)"
                  }}
                >
                  <Box
                    display="flex"
                    width="100%"
                    justifyContent="end"
                    alignItems="flex-end"
                  >
                    <IconButton
                      sx={{
                        svg: {
                          fill: "#FCFCFC"
                        }
                      }}
                      onClick={() => {
                        setCouponModalOpen(false);
                      }}
                    >
                      <Close />
                    </IconButton>
                  </Box>
                  <Typography fontSize={"24px"} fontWeight={600}>
                    Apply Coupon
                  </Typography>
                  <Typography
                    fontSize={"12px"}
                    fontWeight={400}
                    color="#D1D5DB"
                  >
                    Please enter the coupon code to activate the subscription
                  </Typography>
                  <Box
                    display="flex"
                    flexDirection="column"
                    gap={3}
                    width={"100%"}
                    padding={2}
                  >
                    <StyledTextField
                      fullWidth
                      value={inputCouponValue}
                      variant="outlined"
                      name="coupon"
                      placeholder="Enter the coupon code"
                      margin="normal"
                      onChange={handleCouponChange}
                    />
                    <Button
                      fullWidth
                      sx={{
                        backgroundColor: "#368AD0",
                        textTransform: "none",
                        fontWeight: "bold"
                      }}
                      variant="contained"
                      onClick={handleApplyCoupon}
                    >
                      Apply now
                    </Button>
                  </Box>
                  <Snackbar
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                  >
                    <Alert
                      onClose={handleCloseSnackbar}
                      severity={
                        snackbarMessage?.includes("success" || "Success")
                          ? "success"
                          : "error"
                      }
                      sx={{ width: "100%", top: 0, right: 0 }}
                    >
                      {snackbarMessage}
                    </Alert>
                  </Snackbar>
                </Box>
              </Modal>
            )}
          </Box>
        ) : (
          <></>
        )
      ) : (
        <Modal
          open={open}
          onClose={onClose}
          disableAutoFocus
          disableEnforceFocus
        >
          <Box
            sx={{
              position: "absolute",
              top: "30%",
              left: "50%",
              // overflow: "auto",
              height: { xs: "70%", md: "45%" },
              width: { md: "42%", xs: "100%" },
              borderRadius: 2,
              border: "none",
              transform: "translate(-50%, -50%)"
            }}
          >
            <Box
              sx={{
                padding: { xs: "28px", md: 0 },
                position: "relative",
                bgcolor: "#000",
                borderRadius: "16px 16px 0 0",
                boxShadow: 24,
                overflow: "hidden" // Ensures pseudo-element stays within the box
              }}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              //   height={"65%"}
              flexDirection={"column"}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundImage: "url(/images/sky.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  opacity: { xs: 1, md: 0.5 }, // Set the opacity for the background image
                  zIndex: 1 // Ensure it is behind the content
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  zIndex: 2 // Content stays on top of the background
                }}
              >
                <Box
                  display="flex"
                  justifyContent="end"
                  alignItems="flex-end"
                  width="100%"
                >
                  <IconButton
                    sx={{
                      svg: {
                        fill: "#FCFCFC"
                      }
                    }}
                    onClick={onClose}
                  >
                    <Close />
                  </IconButton>
                </Box>
                <Box
                  sx={{ padding: { sm: 0, md: "10px 50px" } }}
                  display={"flex"}
                  gap="10px"
                  flexDirection={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                >
                  <Box
                    component="img"
                    src="/images/threepillars.png"
                    alt="base"
                    sx={{
                      width: "68px",
                      height: "68px",
                      objectFit: "cover"
                    }}
                  />
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap="10px"
                    flexDirection="column"
                  >
                    <Typography
                      fontWeight={600}
                      fontSize={"24px"}
                      color="#FCFCFC"
                      textAlign="center"
                    >
                      Welcome to the Three Pillars Method
                    </Typography>
                    <Typography
                      mt={-1}
                      fontSize={"15px"}
                      color="#FCFCFC"
                      textAlign="center"
                    >
                      {currentUser?.userType === "Company"
                        ? ""
                        : `Your 5 Day Free Trial starts now!`}
                      <br />
                      <Typography
                        fontSize={"15px"}
                        color="#FCFCFC"
                        textAlign="center"
                      >
                        Take this time to explore all the platform has to offer.
                      </Typography>
                    </Typography>
                    <Box
                      alignItems="start"
                      display="flex"
                      flexDirection="column"
                      gap={2}
                    >
                      <Box
                        display="flex"
                        justifyContent={"center"}
                        alignItems="center"
                        gap={2}
                        mt={2}
                      >
                        <Typography
                          display="flex"
                          alignItems={"center"}
                          fontSize={22}
                        >
                          <ModIcon />
                        </Typography>
                        <Typography fontSize={"15px"} color="#FCFCFC">
                          <b>Meals of the Day (MOD): </b> Get inspired with
                          daily ideas and earn a badge by sharing yours with the
                          community.
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent={"center"}
                        alignItems="center"
                        gap={2}
                      >
                        <Typography
                          display="flex"
                          alignItems={"center"}
                          fontSize={22}
                        >
                          <ProgramIcon />
                        </Typography>
                        <Typography fontSize={"15px"} color="#FCFCFC">
                          {currentUser?.userType === "Company" ? (
                            `Get started with the #800gChallenge program to learn more about this simple diet approach.`
                          ) : (
                            <>
                              <b>5 Day Free Trial: </b> Each day will unlock a
                              new training for the #800gChallenge.
                            </>
                          )}
                        </Typography>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent={"center"}
                        alignItems="center"
                        gap={2}
                      >
                        <Typography
                          display="flex"
                          alignItems={"center"}
                          fontSize={22}
                        >
                          <DiaryIcon />
                        </Typography>
                        <Typography fontSize={"15px"} color="#FCFCFC">
                          <b> Diary:</b> Keep yourself accountable with daily
                          logging; earn badges for consistency and streaks.
                        </Typography>
                      </Box>
                    </Box>

                    {currentUser?.userType === "Company" ? (
                      <></>
                    ) : (
                      <Typography
                        textAlign="center"
                        mt={2}
                        fontSize={"15px"}
                        color="#FCFCFC"
                      >
                        {currentUser?.userType === "Coach"
                          ? `At the end of the trial, you can choose to purchase the full #800gChallenge and subsequent programs.`
                          : `At the end of your free trial you can subscribe to have
                      continued access to MODs / Daily Nutrition Logging, and
                      unlock additional Training Programs.`}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                background: "#333333",
                display: "flex",
                padding: "24px 47px",
                borderRadius: "0 0 16px 16px",
                flexDirection: "column"
              }}
            >
              <Box mt={1} display="flex" justifyContent="center">
                <Button
                  disabled={disabledFreeTrial}
                  sx={{
                    width: "70%",
                    color: "#368AD0",
                    textTransform: "none",
                    fontWeight: "bold"
                  }}
                  variant="none"
                  onClick={onClose}
                >
                  Continue Free Trial
                </Button>
              </Box>{" "}
              <Box mt={2} display="flex" justifyContent="center">
                <Button
                  sx={{
                    width: { xs: "100%", md: "70%" },
                    backgroundColor: "#368AD0",
                    textTransform: "none",
                    fontWeight: "bold"
                  }}
                  variant="contained"
                  // onClick={handleSubscribe}
                  onClick={() => {
                    onClose();
                    openSubscriptionModal();
                  }}
                >
                  Purchase Plan Now
                </Button>
              </Box>
              {/* <Box mt={2} display="flex" justifyContent="center">
                <Button
                  sx={{
                    width: { xs: "100%", md: "70%" },
                    backgroundColor: "#368AD0",
                    textTransform: "none",
                    fontWeight: "bold",
                    color: styles.color
                  }}
                  onClick={() => {
                    // onClose();
                    setCouponModalOpen(true);
                  }}
                >
                  Apply Coupon
                </Button>
              </Box> */}
              {couponModalOpen && (
                <Modal
                  disableAutoFocus
                  disableEnforceFocus
                  open={couponModalOpen}
                  onClose={() => {
                    setCouponModalOpen(false);
                    onClose();
                  }}
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      padding: "10px",
                      // height: { xs: "35%", md: "30%" },
                      // width: { xs: "65%", md: "30%" },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      borderRadius: 3,
                      background: "#1C1C1C",
                      color: "#FCFCFC",
                      transform: "translate(-50%, -50%)"
                    }}
                  >
                    <Snackbar
                      open={openSnackbar}
                      autoHideDuration={3000}
                      onClose={handleCloseSnackbar}
                    >
                      <Alert
                        onClose={handleCloseSnackbar}
                        severity={
                          snackbarMessage?.includes("success" || "Success")
                            ? "success"
                            : "error"
                        }
                        sx={{ width: "100%", top: 0, right: 0 }}
                      >
                        {snackbarMessage}
                      </Alert>
                    </Snackbar>
                    <Box
                      display="flex"
                      justifyContent="end"
                      alignItems="flex-end"
                      width="100%"
                    >
                      <IconButton
                        sx={{
                          svg: {
                            fill: "#FCFCFC"
                          }
                        }}
                        onClick={() => {
                          setCouponModalOpen(false);
                        }}
                      >
                        <Close />
                      </IconButton>
                    </Box>
                    <Typography fontSize={"24px"} fontWeight={600}>
                      Apply Coupon
                    </Typography>
                    <Typography
                      sx={{
                        width: "70%",
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "center",
                        textAlign: "center",
                        marginTop: "10px"
                      }}
                      fontSize={"12px"}
                      fontWeight={400}
                      color="#D1D5DB"
                    >
                      Please enter the coupon code to activate the subscription
                    </Typography>
                    <Box
                      display="flex"
                      flexDirection="column"
                      gap={3}
                      width={"100%"}
                      padding={2}
                    >
                      <StyledTextField
                        fullWidth
                        value={inputCouponValue}
                        variant="outlined"
                        name="coupon"
                        placeholder="Enter the coupon code"
                        margin="normal"
                        onChange={handleCouponChange}
                      />
                      <Button
                        fullWidth
                        sx={{
                          backgroundColor: "#368AD0",
                          textTransform: "none",
                          fontWeight: "bold"
                        }}
                        variant="contained"
                        onClick={handleApplyCoupon}
                      >
                        Apply now
                      </Button>
                    </Box>
                  </Box>
                </Modal>
              )}
            </Box>
          </Box>
        </Modal>
      )}
    </>
  );
};

export default FreeTrialModal;
